module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-18-1df79bc9fd6f289ca577b220625cfcbe.jpg";